import { ApiResponseType, BaseResponseType } from '@/types/sharedTypes';
import { authApiService } from '@/api/authApiService';

export const initRecipientDocumentVerificationApi = (wireId: string): Promise<ApiResponseType<BaseResponseType>> => {
  const uri = `/recipient/wires/${wireId}/trust-stamp/init/`;

  return authApiService.POST(uri, {});
};
